@if (!errorMessage) {
    <canvas #renderCanvas></canvas>
} @else {
    <span class="flex flex-row justify-center">
        {{ errorMessage }}
    </span>
}
